import PropTypes from 'prop-types';

import RichText from '../../../Core/RichText';

import {
  Wrapper,
  ScreenNumber,
  Header,
  PhoneVideo,
  StyledImage,
  Body,
} from './styles';

const ProductStep = ({
  data = null,
  className = '',
  index,
  component = null,
  backgroundColor = null,
  showNumber = true,
}) => {
  if (!data) return null;

  const { id, heading, imageDam, textAlignment, bodyCopy, headingColor } = data;

  const isVideoImg = imageDam ? imageDam.asset.mimeType === 'video/mp4' : false;

  return (
    <Wrapper key={id} className={`${className} ${component}`}>
      <Header
        className={`${textAlignment} ${isVideoImg ? `video-asset` : ''}`}
        headingColor={headingColor}
      >
        {showNumber && (
          <ScreenNumber className={backgroundColor}>
            <p>{index}</p>
          </ScreenNumber>
        )}
        {heading && <RichText document={heading} />}
      </Header>
      {bodyCopy && (
        <Body>
          <RichText document={bodyCopy} />
        </Body>
      )}
      {isVideoImg && imageDam && (
        <PhoneVideo
          key={imageDam.id}
          url={imageDam.asset.localImage.publicURL}
          controls={false}
          loop
        />
      )}
      {!isVideoImg && imageDam && (
        <StyledImage key={imageDam.id} src={imageDam} alt="" />
      )}
    </Wrapper>
  );
};

ProductStep.propTypes = {
  data: PropTypes.shape(),
  className: PropTypes.string,
  index: PropTypes.number.isRequired,
  component: PropTypes.string,
  backgroundColor: PropTypes.string,
  showNumber: PropTypes.bool,
};

export default ProductStep;
